import moment from "moment";

export const DateComponent = ({ date, text, timeFormat = 'DD-MM-YYYY hh:mm A', className = 'text-sm' }) => {
    return <small>
        <b className={className}>{`${text ? text : ''}`} {moment(date).format(timeFormat)}</b>
    </small>
}